/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const warningExclamation = {
  src: '/images/notification/icon-caution.svg',
  alt: 'warning exclamation',
};
